import { COMPOSER_BAR_CONTROL_H } from './composerConstants.ts';

export const COMPOSER_ACTION_PILL_PROPS = {
	type: 'button',
	variant: 'outline',
	size: 'sm',
	h: COMPOSER_BAR_CONTROL_H,
	minH: COMPOSER_BAR_CONTROL_H,
	rounded: 'full',
	fontSize: 'sm',
	fontWeight: 'medium',
	color: 'brand.fg',
	bg: 'surface.default',
	boxShadow: 'xs',
	gap: 1.5,
	flexShrink: 0,
	_hover: { bg: 'colorPalette.subtle' },
	_expanded: { bg: 'colorPalette.subtle' },
} as const;

// Leading-icon + label pills share the same optical padding across File, Email and Sub-task.
export const COMPOSER_ACTION_LABEL_PILL_PROPS = {
	...COMPOSER_ACTION_PILL_PROPS,
	ps: 3,
	pe: 4,
} as const;
